import React from 'react'
import {Route, Switch} from 'react-router-dom'
import ListDirectors from './ListDirectors'
import NewDirectorPage from './NewDirectorPage'
import EditDirectorPage from './EditDirectorPage'
import ShowDirectorPage from './ShowDirectorPage'

const Directors = ({match}) => (
  <Switch>
    <Route exact path={match.url + '/'} component={ListDirectors} />
    <Route exact path={match.url + '/new'} component={NewDirectorPage} />
    <Route path={match.url + '/:id/edit'} component={EditDirectorPage} />
    <Route path={match.url + '/:id'} component={ShowDirectorPage} />
  </Switch>
)

export default Directors



// WEBPACK FOOTER //
// ./src/components/Directors/Directors.jsx